export const WebpDescriptions: Record<string, string> = {
  RIFF: "Resource Interchange File Format. The container format for WebP.",
  WEBP: "WebP Signature. Identifies the file as a WebP image.",
  VP8: "VP8 Chunk. Contains simple lossy image data (legacy format).",
  VP8L: "VP8L Chunk. Contains lossless image data.",
  VP8X: "VP8X Chunk. Extended header. Indicates the presence of advanced features like animation, alpha channel, or EXIF/XMP metadata.",
  ALPH: "Alpha Chunk. Contains transparency data for the image.",
  ANIM: "Animation Chunk. Global parameters for an animated image (background color, loop count).",
  ANMF: "Animation Frame Chunk. Contains a single frame of an animation sequence.",
  ICCP: "ICC Profile. Embedded color profile.",
  EXIF: "Exif Metadata. Exchangeable image file format data (camera settings, etc).",
  XMP: "XMP Metadata. Extensible Metadata Platform data.",
  MUX: "Mux Chunk. Indicates the file uses the extended format.",
};

export const getWebpDescription = (name: string): string => {
  return WebpDescriptions[name.trim()] || "WebP Chunk.";
};
